module.exports = __webpack_public_path__ + "static/media/cnx-pay-Mastercard.14c35556.svg";